

import { uploadDemoGraphicConstants } from '../../_constants/uploadDemographic.constants';

const initialState = { demoGraphicCsvUpload_loading : true, demoGraphicCsvUpload_response: '', demoGraphicCsvUpload_error: false};

export function demoGraphicCsvUpload(state = initialState, action) {
    switch (action.type) {
      case uploadDemoGraphicConstants.REQUEST_UPLOAD_CSV:
        return {
            demoGraphicCsvUpload_loading: true,
            demoGraphicCsvUpload_response: '',
            demoGraphicCsvUpload_error: false
        };
      case uploadDemoGraphicConstants.RECIEVE_UPLOAD_CSV:
        return {
            demoGraphicCsvUpload_loading: false,
            demoGraphicCsvUpload_response: action.UploadDemographicData,
            demoGraphicCsvUpload_error: false
        };
      case uploadDemoGraphicConstants.ERROR_UPLOAD_CSV:
        return { 
            demoGraphicCsvUpload_loading: false,
            demoGraphicCsvUpload_response: '',
            demoGraphicCsvUpload_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/uploadDemoGraphic/demoGraphicCsvUpload.reducer.js